<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :hasChanges="hasChanges"
    :customClass="'invoice-create create-form'"
    v-if="getPermission('invoice:create') || getPermission('invoice:update')"
  >
    <template v-slot:header-title>
      <div class="d-flex justify-space-between">
        <h1 class="form-title d-flex align-baseline">
          Invoice for
          <div
            v-if="vCustomerId"
            class="ml-3 form-title-link text-h5"
            :class="{ 'cursor-pointer': !invoiceEditId }"
            v-on:click="openDialog('customer')"
          >
            {{ vCustomer.display_name }}
          </div>
          <template v-else>
            <div
              class="ml-3 form-title-link text-h5"
              :class="{ 'cursor-pointer': !invoiceEditId }"
              v-on:click="openDialog('customer')"
            >
              Select a Customer
              <v-icon large color="cyan">mdi-account-check-outline</v-icon>
            </div>
          </template>
          <!-- <span
            class="form-title-link cursor-pointer"
            v-on:click="openDialog('customer')"
          >
            <template v-if="vCustomerId">{{ vCustomer.display_name }}</template>
            <template v-else>
              Select a Customer
              <v-icon large color="cyan">mdi-plus-circle-outline</v-icon>
            </template>
          </span> -->
        </h1>
        <div>
          <v-chip
            v-if="dbInvoice?.barcode"
            label
            color="chip-custom-blue"
            outlined
            class="text-white p-3 mr-4"
            style="font-size: 21px !important; font-weight: 700"
          >
            <template>
              {{ dbInvoice.barcode }}
            </template>
          </v-chip>
        </div>
      </div>
    </template>
    <template v-slot:header-action
      ><div>
        <v-btn
          :disabled="formLoading"
          v-on:click="goBack() /* ;clearLocalStorage() */"
          class="custom-bold-button custom-grey-border"
          depressed
          >Cancel</v-btn
        >
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          :disabled="
            !formValid ||
            formLoading ||
            (customError &&
              (dbInvoice?.billing_type == 'recurring' ||
                dbInvoice?.billing_type == 'recurring-based-on-quote'))
              ? true
              : false
          "
          :loading="formLoading"
          v-on:click="validateJob('draft')"
          color="cyan white--text"
          >Save As Draft</v-btn
        >
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          :disabled="
            !formValid ||
            formLoading ||
            (customError && dbInvoice?.billing_type == 'recurring') ||
            dbInvoice?.billing_type == 'recurring-based-on-quote'
              ? true
              : false
          "
          :loading="formLoading"
          v-on:click="validateJob('send')"
          color="cyan white--text"
          >Save & Send</v-btn
        >
      </div></template
    >
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow product-create-height"
        style="height: calc(100vh - 145px); position: relative"
      >
        <div class="bg-white px-2">
          <v-form
            ref="createInvoiceForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="validateJob()"
          >
            <v-row>
              <v-col md="7" class="pt-0">
                <label
                  for="visit-title"
                  class="required font-size-16 font-weight-500"
                  >Invoice Title</label
                >
                <TextField
                  id="quotation-title"
                  dense
                  filled
                  placeholder="Title"
                  solo
                  flat
                  counter="100"
                  v-model="dbInvoice.title"
                  color="cyan"
                  :maxlength="100"
                  :rules="[validateRules.required(dbInvoice.title, 'Title')]"
                />

                <TextAreaField
                  auto-grow
                  dense
                  filled
                  color="cyan"
                  v-model="dbInvoice.description"
                  placeholder="Description"
                  solo
                  flat
                  row-height="25"
                  counter="250"
                />
                <v-row class="mt-1">
                  <!-- Billing Location Card -->
                  <v-col md="6" class="d-flex flex-column">
                    <v-card
                      flat
                      outlined
                      class="rounded-lg bg-slate-50 pa-3 h-100 border-slate"
                    >
                      <div
                        class="d-flex align-center justify-space-between pb-2 mb-2 custom-border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="cyan darken-2" small class="mr-2"
                            >mdi-map-marker-radius-outline</v-icon
                          >
                          <span
                            class="font-weight-700 font-size-14 color-custom-blue"
                            >Billing Location</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan"
                          class="bg-white custom-grey-border"
                          v-on:click="openDialog('billing')"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>

                      <template v-if="vBilling?.id">
                        <div class="mb-2">
                          <div
                            class="font-weight-600 font-size-13 text-slate-800 d-flex align-center"
                            v-if="vBilling.property_name"
                          >
                            <v-icon small color="slate-600" class="mr-1"
                              >mdi-home-map-marker</v-icon
                            >
                            {{ vBilling.property_name }}
                          </div>
                          <div
                            class="d-flex align-start font-size-12 text-slate-700 mt-1"
                            v-if="vBilling.property_address"
                          >
                            <v-icon small color="slate-500" class="mr-1 mt-1"
                              >mdi-map-marker-outline</v-icon
                            >
                            <div>{{ vBilling.property_address }}</div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-2 font-size-12 red--text font-weight-500">
                          Please select billing location
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-2 font-size-12 red--text font-weight-500">
                          Please select customer
                        </p>
                      </template>

                      <!-- Contact Details Sub-section -->
                      <div
                        class="d-flex align-center justify-space-between pb-2 mb-2 custom-border-bottom pt-2 border-top-slate"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="cyan darken-2" small class="mr-2"
                            >mdi-account-outline</v-icon
                          >
                          <span
                            class="font-weight-700 font-size-14 color-custom-blue"
                            >Contact Details</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan"
                          class="bg-white custom-grey-border"
                          v-on:click="openDialog('billing-contact')"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                      <template v-if="vBillingContact?.id">
                        <div class="font-size-12 text-slate-800 mt-1">
                          <div class="font-weight-600 color-custom-blue">
                            <v-icon small color="slate-600" class="mr-1"
                              >mdi-account-outline</v-icon
                            >
                            {{ vBillingContact.display_name }}
                          </div>
                          <div
                            v-if="vBillingContact.primary_phone"
                            class="text-slate-600"
                          >
                            <v-icon small color="slate-500" class="mr-1"
                              >mdi-phone-outline</v-icon
                            >
                            {{ vBillingContact.primary_phone }}
                          </div>
                          <div
                            v-if="vBillingContact.primary_email"
                            class="text-slate-600"
                          >
                            <v-icon small color="slate-500" class="mr-1"
                              >mdi-email-outline</v-icon
                            >
                            {{ vBillingContact.primary_email }}
                          </div>
                        </div>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-0 font-size-12 red--text font-weight-500">
                          Please select contact person
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-0 font-size-12 red--text font-weight-500">
                          Please select customer
                        </p>
                      </template>

                      <div
                        class="d-flex align-center justify-space-between mt-3 pt-2 border-top-slate"
                      >
                        <label
                          class="my-0 font-size-12 font-weight-600 text-slate-700"
                          >Email Notification</label
                        >
                        <v-switch
                          v-model="dbInvoice.notify_billing_contact_person"
                          class="m-0 p-0"
                          color="cyan"
                          :false-value="0"
                          :true-value="1"
                          dense
                          inset
                          hide-details
                        />
                      </div>
                    </v-card>
                  </v-col>

                  <!-- Site Location Card -->
                  <v-col md="6" class="d-flex flex-column">
                    <v-card
                      flat
                      outlined
                      class="rounded-lg bg-slate-50 pa-3 h-100 border-slate"
                    >
                      <div
                        class="d-flex align-center justify-space-between pb-2 mb-2 custom-border-bottom"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="cyan darken-2" small class="mr-2"
                            >mdi-map-marker-radius-outline</v-icon
                          >
                          <span
                            class="font-weight-700 font-size-14 color-custom-blue"
                            >Site Location</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan"
                          class="bg-white custom-grey-border"
                          v-on:click="openDialog('property')"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>

                      <template v-if="vProperty?.id">
                        <div class="mb-2">
                          <div
                            class="font-weight-600 font-size-13 text-slate-800 d-flex align-center"
                            v-if="vProperty.property_name"
                          >
                            <v-icon small color="slate-600" class="mr-1"
                              >mdi-home-map-marker</v-icon
                            >
                            {{ vProperty.property_name }}
                          </div>
                          <div
                            class="d-flex align-start font-size-12 text-slate-700 mt-1"
                            v-if="vProperty.property_address"
                          >
                            <v-icon small color="slate-500" class="mr-1 mt-1"
                              >mdi-map-marker-outline</v-icon
                            >
                            <div>{{ vProperty.property_address }}</div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-2 font-size-12 red--text font-weight-500">
                          Please select service location
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-2 font-size-12 red--text font-weight-500">
                          Please select customer
                        </p>
                      </template>

                      <!-- Contact Details Sub-section -->
                      <div
                        class="d-flex align-center justify-space-between pb-2 mb-2 custom-border-bottom pt-2 border-top-slate"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="cyan darken-2" small class="mr-2"
                            >mdi-account-outline</v-icon
                          >
                          <span
                            class="font-weight-700 font-size-14 color-custom-blue"
                            >Contact Details</span
                          >
                        </div>
                        <v-btn
                          icon
                          x-small
                          color="cyan"
                          class="bg-white custom-grey-border"
                          v-on:click="openDialog('property-contact')"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                      <template v-if="vPropertyContact?.id">
                        <div class="font-size-12 text-slate-800 mt-1">
                          <div class="font-weight-600 color-custom-blue">
                            <v-icon small color="slate-600" class="mr-1"
                              >mdi-account-outline</v-icon
                            >
                            {{ vPropertyContact.display_name }}
                          </div>
                          <div
                            v-if="vPropertyContact.primary_phone"
                            class="text-slate-600"
                          >
                            <v-icon small color="slate-500" class="mr-1"
                              >mdi-phone-outline</v-icon
                            >
                            {{ vPropertyContact.primary_phone }}
                          </div>
                          <div
                            v-if="vPropertyContact.primary_email"
                            class="text-slate-600"
                          >
                            <v-icon small color="slate-500" class="mr-1"
                              >mdi-email-outline</v-icon
                            >
                            {{ vPropertyContact.primary_email }}
                          </div>
                        </div>
                      </template>
                      <template v-else-if="vCustomer?.id">
                        <p class="mb-0 font-size-12 red--text font-weight-500">
                          Please select contact person
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-0 font-size-12 red--text font-weight-500">
                          Please select customer
                        </p>
                      </template>

                      <div
                        class="d-flex align-center justify-space-between mt-3 pt-2 border-top-slate"
                      >
                        <label
                          class="my-0 font-size-12 font-weight-600 text-slate-700"
                          >Email Notification</label
                        >
                        <v-switch
                          v-model="dbInvoice.notify_property_contact_person"
                          class="m-0 p-0"
                          color="cyan"
                          :false-value="0"
                          :true-value="1"
                          :disabled="formLoading"
                          dense
                          inset
                          hide-details
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <v-col md="5" class="pt-0">
                <table
                  width="100%"
                  style="table-layout: fixed"
                  v-if="is_allowed_recur_invoice"
                >
                  <tr>
                    <!-- <td>
                        <label for="invoice-id">Type</label>
                      </td> 
                    <td colspan="2" width="100%">
                      <div class="d-flex mt-4">
                        <v-btn
                          depressed
                          tile
                          :outlined="!(dbInvoice.billing_type == 'one-off')"
                          v-on:click="dbInvoice.billing_type = 'one-off'"
                          value="one-off"
                          color="red darken-3 white--text"
                          :disabled="
                            invoiceEditId &&
                            (dbUpdateInvoice?.invoice?.billing_type ==
                              'recurring' ||
                              dbUpdateInvoice?.invoice?.billing_type ==
                                'recurring-based-on-quote')
                              ? true
                              : false
                          "
                          style="font-size: 15px; margin-right: 20px"
                          >One-Off</v-btn
                        >
                       <v-btn
                          style="font-size: 15px; margin-right: 20px"
                          class="mx-2"
                          depressed
                          tile
                          :outlined="!(dbInvoice.billing_type == 'recurring')"
                          v-on:click="dbInvoice.billing_type = 'recurring'"
                          value="recurring"
                          color="green darken-4 white--text"
                          :disabled="
                            invoiceEditId &&
                            dbUpdateInvoice?.invoice?.billing_type == 'one-off'
                              ? true
                              : false
                          "
                          >Recurring</v-btn
                        > 
                      </div>
                    </td> -->
                  </tr>
                </table>
                <table
                  width="100%"
                  style="table-layout: fixed"
                  v-if="
                    (dbInvoice?.billing_type == 'recurring' ||
                      dbInvoice?.billing_type == 'recurring-based-on-quote') &&
                    !invoiceEditId
                  "
                >
                  <tr>
                    <td width="100%">
                      <div>
                        <RecurringSchedule
                          :key="`job-recurring-schedule-${scheduleKey}`"
                        />
                      </div>
                    </td>
                  </tr>
                </table>
                <table
                  width="100%"
                  class="invoice-details-table"
                  style="table-layout: fixed"
                >
                  <tr
                    v-if="
                      (dbInvoice?.billing_type == 'recurring' ||
                        dbInvoice?.billing_type ==
                          'recurring-based-on-quote') &&
                      !invoiceEditId
                    "
                  >
                    <td width="20%" v-if="false">
                      <label for="invoice-id">Type</label>
                    </td>
                    <td width="80%" v-if="false">
                      <v-autocomplete
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.recurring_type"
                        item-text="text"
                        item-value="value"
                        item-color="cyan"
                        filled
                        :items="recurringTypeList"
                        hide-details
                        placeholder="Recurring Invoive"
                        solo
                        flat
                        color="cyan"
                      />
                    </td>
                    <!-- <td width="40%">
                        <v-text-field
                         v-on:keypress="isNumber()" 
                          type="number"
                          dense
                          filled
                          hide-details
                          placeholder="Duration"
                          solo
                          flat
                          :disabled="formLoading"
                          :loading="formLoading"
                          :value="dbInvoice.recurring_duration_new"
                          color="cyan"
                        />   
                      </td> -->
                  </tr>
                  <tr v-if="false">
                    <td width="20%" colspan="2">
                      <label for="invoice-id">Invoice #</label>
                    </td>
                    <td>
                      <v-text-field
                        id="invoice-id"
                        dense
                        filled
                        readonly
                        hide-details
                        placeholder="Invoice #"
                        :maxlength="250"
                        solo
                        flat
                        :disabled="formLoading"
                        :loading="formLoading"
                        :value="dbInvoice.barcode"
                        color="cyan"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      <label
                        class="font-size-16 font-weight-500"
                        for="reference"
                        >Ref No</label
                      >
                    </td>
                    <td width="80%" colspan="2">
                      <TextField
                        id="reference"
                        dense
                        filled
                        placeholder="Ref No."
                        solo
                        flat
                        counter="50"
                        v-model="dbInvoice.customer_ref"
                        color="cyan"
                        :maxlength="50"
                      />
                      <v-text-field
                        v-if="false"
                        id="reference"
                        dense
                        filled
                        v-model="dbInvoice.customer_ref"
                        :maxlength="100"
                        hide-details
                        placeholder="Ref No"
                        solo
                        flat
                        :disabled="formLoading"
                        :loading="formLoading"
                        color="cyan"
                      />
                    </td>
                  </tr>
                  <tr
                    v-if="
                      (dbInvoice.billing_type != 'recurring' &&
                        !invoiceEditId) ||
                      invoiceEditId > 0
                    "
                  >
                    <td width="20%">
                      <label
                        class="font-size-16 font-weight-500"
                        for="invoice-date"
                        >Invoice Date</label
                      >
                    </td>
                    <td width="80%" colspan="2">
                      <date-picker
                        :disabled="formLoading"
                        :loading="formLoading"
                        key="invoice-date"
                        id="invoice-date"
                        :min-date="todayDate"
                        placeholder="Invoice Date"
                        v-model="dbInvoice.date"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      <label
                        class="font-size-16 font-weight-500"
                        for="payment-due"
                        >Payment due</label
                      >
                    </td>
                    <td width="80%" colspan="2">
                      <v-autocomplete
                        id="payment-due"
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.payment_due"
                        item-text="text"
                        item-value="id"
                        item-color="cyan"
                        filled
                        :items="paymentDueList"
                        hide-details
                        placeholder="Payment due"
                        solo
                        flat
                        color="cyan"
                      />
                    </td>
                  </tr>
                  <tr
                    class="pdf-source-row"
                    @dragover="dragOverPdfSource('quotation', $event)"
                    @drop="dropPdfSource('quotation', $event)"
                  >
                    <td width="20%">
                      <div
                        class="d-flex flex-no-wrap align-center font-size-16 font-weight-500"
                      >
                        <span
                          class="pdf-source-drag-handle"
                          data-source-type="quotation"
                          draggable="true"
                          @dragstart="dragPdfSource('quotation', $event)"
                          @dragend="endDragPdfSource"
                          ><v-icon>mdi-drag</v-icon></span
                        >
                        Quotation
                      </div>
                    </td>
                    <td width="80%" colspan="2" class="pdf-source-control-cell">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="d-inline-flex pdf-source-checkbox"
                          >
                            <v-checkbox
                              v-model="pdfSourceVisibility.quotation"
                              color="cyan"
                              dense
                              hide-details
                              class="mr-2"
                              @change="updatePdfSourceVisibility('quotation')"
                            />
                          </span>
                        </template>
                        <span
                          >Include selected quotations in the invoice PDF.</span
                        >
                      </v-tooltip>
                      <v-autocomplete
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.quotations"
                        class="d-inline-flex pdf-source-autocomplete"
                        item-text="job_title"
                        item-value="id"
                        item-color="cyan"
                        filled
                        :items="quotationList"
                        :filter="quotationFilter"
                        hide-details
                        placeholder="Select Quotation"
                        solo
                        flat
                        color="cyan"
                        multiple
                        @change="onQuotationChange"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                >No Quotation(s) Found.</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ item, index }">
                          <v-chip
                           v-if="index === 0"
                            small
                            label
                            close
                            color="grey lighten-4"
                            class="mr-1 my-1"
                            @click:close="removeQuotation(item.id || item)"
                          >
                            <!--  <span
                              class="font-weight-600 mr-1 primary--text"
                              v-if="getQuotationItem(item).barcode"
                            >
                              {{ getQuotationItem(item).barcode }}
                            </span> -->
                            <span
                              class="mr-1 font-weight-500 text-truncate"
                              style="max-width: 100px"
                            >
                              {{ getQuotationItem(item).job_title }}
                            </span>
                            <span
                              v-if="getQuotationItem(item).date"
                              class="grey--text text--darken-2 font-size-11 mr-2"
                            >
                              ({{
                                formatQuotationDate(
                                  getQuotationItem(item).date
                                )
                              }})
                            </span>
                            <v-chip
                              v-if="
                                getQuotationStatusText(getQuotationItem(item))
                              "
                              x-small
                              label
                              :color="
                                getQuotationStatusColor(getQuotationItem(item))
                              "
                              :text-color="
                                getQuotationStatusTextColor(
                                  getQuotationItem(item)
                                )
                              "
                              class="font-weight-600 text-uppercase"
                              style="
                                height: 18px;
                                font-size: 10px;
                                padding: 0 4px;
                              "
                            >
                              {{
                                getQuotationStatusText(getQuotationItem(item))
                              }}
                            </v-chip>
                          </v-chip>
                          <span v-else-if="index === 1" class="text-caption">
                            (+{{ dbInvoice.quotations.length - 1 }} more)</span>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-action class="mr-3 my-0">
                            <v-simple-checkbox
                              :value="
                                (dbInvoice.quotations || []).includes(item.id)
                              "
                              color="cyan"
                              style="pointer-events: none"
                            ></v-simple-checkbox>
                          </v-list-item-action>
                          <v-list-item-content class="py-2">
                            <div
                              class="d-flex align-center justify-space-between w-100"
                            >
                              <div
                                class="d-flex align-center text-truncate mr-2"
                              >
                                <!--  <span
                                  v-if="item.barcode"
                                  class="font-weight-700 primary--text mr-2 font-size-13"
                                >
                                  {{ item.barcode }}
                                </span> -->
                                <span
                                  class="font-weight-500 text-truncate font-size-13"
                                  :title="item.job_title"
                                >
                                  {{ item.job_title }}
                                </span>
                              </div>
                              <div class="d-flex align-center flex-shrink-0">
                                <span
                                  v-if="item.date"
                                  class="font-size-12 grey--text text--darken-2 mr-3 d-flex align-center"
                                >
                                  <v-icon
                                    x-small
                                    class="mr-1"
                                    color="grey darken-1"
                                    >mdi-calendar-range</v-icon
                                  >
                                  {{ formatQuotationDate(item.date) }}
                                </span>
                                <v-chip
                                  small
                                  label
                                  :color="getQuotationStatusColor(item)"
                                  :text-color="
                                    getQuotationStatusTextColor(item)
                                  "
                                  class="font-weight-600 text-uppercase font-size-11"
                                >
                                  {{ getQuotationStatusText(item) }}
                                </v-chip>
                              </div>
                            </div>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </td>
                  </tr>
                  <tr
                    class="pdf-source-row"
                    @dragover="dragOverPdfSource('contract', $event)"
                    @drop="dropPdfSource('contract', $event)"
                  >
                    <td width="20%">
                      <div
                        class="d-flex flex-no-wrap align-center font-size-16 font-weight-500"
                      >
                        <span
                          class="pdf-source-drag-handle"
                          data-source-type="contract"
                          draggable="true"
                          @dragstart="dragPdfSource('contract', $event)"
                          @dragend="endDragPdfSource"
                          ><v-icon>mdi-drag</v-icon></span
                        >
                        Contract
                      </div>
                    </td>
                    <td width="80%" colspan="2" class="pdf-source-control-cell">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="d-inline-flex pdf-source-checkbox"
                          >
                            <v-checkbox
                              v-model="pdfSourceVisibility.contract"
                              color="cyan"
                              dense
                              hide-details
                              class="mr-2"
                              @change="updatePdfSourceVisibility('contract')"
                            />
                          </span>
                        </template>
                        <span
                          >Include selected contracts in the invoice PDF.</span
                        >
                      </v-tooltip>
                      <v-autocomplete
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.contracts"
                        class="d-inline-flex pdf-source-autocomplete"
                        item-text="job_title"
                        item-value="id"
                        item-color="cyan"
                        filled
                        :items="contractList"
                        hide-details
                        placeholder="Select Contract"
                        solo
                        flat
                        color="cyan"
                        multiple
                        @change="onContractChange"
                      >
                        <template v-slot:selection="{ item, index }">
                          <span
                            v-if="index === 0"
                            class="mr-1 font-weight-500 text-truncate"
                            style="max-width: 250px"
                            :title="item.job_title"
                          >
                            {{ item.job_title }}
                          </span>

                          <span v-else-if="index === 1" class="text-caption">
                            (+{{ dbInvoice.contracts.length - 1 }} more)
                          </span>
                        </template>
                      </v-autocomplete>
                     
                      <v-autocomplete
                        v-if="false"
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.contracts"
                        class="d-inline-flex pdf-source-autocomplete"
                        item-text="job_title"
                        item-value="id"
                        item-color="cyan"
                        filled
                        :items="contractList"
                        hide-details
                        placeholder="Select Contract"
                        solo
                        flat
                        color="cyan"
                        multiple
                        @change="onContractChange"
                      />
                    </td>
                  </tr>
                  <tr
                    class="pdf-source-row"
                    @dragover="dragOverPdfSource('visit', $event)"
                    @drop="dropPdfSource('visit', $event)"
                  >
                    <td width="20%">
                      <div
                        class="d-flex flex-no-wrap align-center font-size-16 font-weight-500"
                      >
                        <span
                          class="pdf-source-drag-handle"
                          data-source-type="visit"
                          draggable="true"
                          @dragstart="dragPdfSource('visit', $event)"
                          @dragend="endDragPdfSource"
                          ><v-icon>mdi-drag</v-icon></span
                        >
                        Visits
                      </div>
                    </td>
                    <td width="80%" colspan="2" class="pdf-source-control-cell">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="d-inline-flex pdf-source-checkbox"
                          >
                            <v-checkbox
                              v-model="pdfSourceVisibility.visit"
                              color="cyan"
                              dense
                              hide-details
                              class="mr-2"
                              @change="updatePdfSourceVisibility('visit')"
                            />
                          </span>
                        </template>
                        <span>Include selected visits in the invoice PDF.</span>
                      </v-tooltip>
                      <v-autocomplete
                        id="payment-due-visits"
                        dense
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="dbInvoice.visits"
                        class="d-inline-flex pdf-source-autocomplete"
                        item-text="title"
                        item-value="id"
                        item-color="cyan"
                        filled
                        :items="visitList"
                        hide-details
                        placeholder="Select Visits"
                        solo
                        flat
                        color="cyan"
                        multiple
                        @change="onVisitChange"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                >No Visit(s) Found.</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ item, index }">
                          <v-chip
                            v-if="index === 0"
                            small
                            label
                            close
                            color="grey lighten-4"
                            class="mr-1 my-1"
                            @click:close="removeVisit(item.id || item)"
                          >
                            <span
                              class="font-weight-600 mr-1 text-truncate"
                              v-if="item.title"
                              style="max-width: 100px"
                            >
                              {{ item.title }}
                            </span>
                            <span
                              v-if="item.quotation_barcode"
                              class="mr-1 font-weight-500 primary--text"
                              style="max-width: 120px"
                            >
                              {{ item.quotation_barcode }}
                            </span>

                            <v-chip
                              x-small
                              label
                              :color="'green'"
                              :text-color="'white'"
                              class="font-weight-600 text-uppercase"
                              style="
                                height: 18px;
                                font-size: 10px;
                                padding: 0 4px;
                              "
                            >
                              Completed
                            </v-chip>
                          </v-chip>
                          <span v-else-if="index === 1" class="text-caption">
                            (+{{ dbInvoice.visits.length - 1 }} more)
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-action class="mr-3 my-0">
                            <v-simple-checkbox
                              :value="
                                (dbInvoice.visits || []).includes(item.id)
                              "
                              color="cyan"
                              style="pointer-events: none"
                            ></v-simple-checkbox>
                          </v-list-item-action>
                          <v-list-item-content class="py-2">
                            <div
                              class="d-flex align-center justify-space-between w-100"
                            >
                              <div
                                class="d-flex align-center text-truncate mr-2"
                              >
                                <span
                                  v-if="item.title"
                                  class="font-weight-700 mr-2 font-size-13"
                                >
                                  {{ item.title }}
                                </span>
                                <!--  <span
                                 v-if="item.quotation_barcode"
                                  class="font-weight-500 text-truncate font-size-13 primary--text"
                                  :title="item.quotation_barcode"
                                >
                                  {{ item.quotation_barcode }}
                                </span> -->
                              </div>
                              <div class="d-flex align-center flex-shrink-0">
                                <span
                                  v-if="item.quotation_barcode"
                                  class="font-weight-500 text-truncate font-size-13 primary--text mr-2"
                                  :title="item.quotation_barcode"
                                >
                                  {{ item.quotation_barcode }}
                                </span>
                                <v-chip
                                  x-small
                                  label
                                  :color="'green'"
                                  :text-color="'white'"
                                  class="font-weight-600 text-uppercase"
                                  style="
                                    height: 18px;
                                    font-size: 10px;
                                    padding: 0 4px;
                                  "
                                >
                                  Completed
                                </v-chip>
                              </div>
                            </div>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </td>
                  </tr>
                  <tr v-if="dbInvoice.payment_due == 5">
                    <td width="20%">
                      <label class="font-size-16 font-weight-500" for="due-date"
                        >Due date</label
                      >
                    </td>
                    <td width="80%" colspan="2">
                      <date-picker
                        :disabled="formLoading"
                        :loading="formLoading"
                        key="due-date"
                        id="due-date"
                        :min-date="dbInvoice.date"
                        placeholder="Due Date"
                        v-model="dbInvoice.due_date"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <div
                        class="font-weight-600"
                        style="color: black; font-size: 15px"
                      >
                        {{ $route?.query?.message }}
                      </div>
                    </td>
                  </tr>
                  <!--  <tr v-if="dbQuotation?.id">
              <td>
                <label class="font-size-16 font-weight-500" for="quotation-id">Quotation</label>
              </td>
              <td>
                <v-text-field
                  id="quotation-id"
                  dense
                  filled
                  readonly
                  :value="`${dbQuotation.barcode} - ${dbQuotation.title}`"
                  hide-details
                  placeholder="Quotation"
                  solo
                  flat
                  :disabled="formLoading"
                  :loading="formLoading"
                  color="cyan"
                />
              </td>
            </tr>
            <tr v-else>
              <td>
                <label class="font-size-16 font-weight-500" for="quotation-list">Quotation</label>
              </td>
              <td>
                <v-autocomplete
                  id="quotation-list"
                  dense
                  :items="vRelatedQuotations"
                  filled
                  v-model="dbInvoice.quotation"
                  hide-details
                  placeholder="Quotation"
                  item-text="text"
                  item-color="cyan"
                  item-value="value"
                  solo
                  flat
                  :disabled="formLoading"
                  :loading="formLoading"
                  color="cyan"
                />
              </td>
            </tr> -->
                  <!--  <tr v-if="dbVisit?.id">
              <td>
                <label class="font-size-16 font-weight-500" for="visit-id">Visit</label>
              </td>
              <td>
                <v-text-field
                  id="visit-id"
                  dense
                  filled
                  readonly
                  :value="`${dbVisit?.visit?.barcode} - ${dbVisit?.visit?.title}`"
                  hide-details
                  placeholder="Visit"
                  solo
                  flat
                  :disabled="formLoading"
                  :loading="formLoading"
                  color="cyan"
                />
              </td>
            </tr>
            <tr v-else>
              <td>
                <label class="font-size-16 font-weight-500" for="visit-list">Visit</label>
              </td>
              <td>
                <v-autocomplete
                  id="visit-list"
                  dense
                  :items="vRelatedVisits"
                  filled
                  v-model="dbInvoice.visit"
                  hide-details
                  placeholder="Visit"
                  item-text="text"
                  item-color="cyan"
                  item-value="value"
                  solo
                  flat
                  :disabled="formLoading"
                  :loading="formLoading"
                  color="cyan"
                />
              </td>
            </tr> -->
                </table>
              </v-col>
              <v-col cols="12" ref="qtLineItem">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      Line Items
                    </h3>
                  </v-card-title>
                  <v-card-text class="font-size-16 py-0">
                    <line-item
                      :unit="unit"
                      :related-type="related_type"
                      :related-detail="dbUpdateInvoice?.invoice"
                      :key="`invoice-line-item-${uniqueId}`"
                      is-invoice
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ref="qtPaymentTerm">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      PAYMENT TERMS
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <v-autocomplete
                      v-if="false"
                      dense
                      color="cyan"
                      filled
                      label="Payment Terms"
                      solo
                      flat
                      class="my-2"
                      item-color="cyan"
                      item-text="label"
                      item-value="id"
                      hide-details
                      :disabled="formLoading"
                      :loading="formLoading"
                      :items="paymentTermList"
                      v-model="dbInvoice.payment_term_id"
                      v-on:change="update_payment_term()"
                    >
                    </v-autocomplete>
                    <TinyMCE v-model="dbInvoice.payment_terms" />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ref="qtTermCondition">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      Terms &amp; Conditions
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <v-autocomplete
                      dense
                      color="cyan"
                      filled
                      label="Terms &amp; Conditions"
                      solo
                      flat
                      class="my-2"
                      item-color="cyan"
                      item-text="label"
                      item-value="id"
                      hide-details
                      :disabled="formLoading"
                      :loading="formLoading"
                      :items="termsConditionList"
                      v-model="dbInvoice.term_condition_id"
                      v-on:change="update_term_condition()"
                    >
                    </v-autocomplete>
                    <TinyMCE v-model="dbInvoice.term_conditions" />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ref="qtNote">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      INTERNAL NOTES &amp; ATTACHMENTS
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <v-row dense>
                      <!-- Internal Note Card -->
                      <v-col cols="12" md="6" class="py-2">
                        <v-card
                          flat
                          outlined
                          class="rounded-lg pa-4 green lighten-5 h-100"
                        >
                          <div
                            class="d-flex align-center justify-space-between mb-3 pb-2 border-bottom"
                          >
                            <div class="d-flex align-center">
                              <v-icon color="green darken-1" small class="mr-2"
                                >mdi-shield-lock-outline</v-icon
                              >
                              <label
                                class="font-weight-bold font-size-16 primary--text mb-0 cursor-pointer"
                              >
                                Internal Note
                              </label>
                            </div>
                          </div>
                          <v-autocomplete
                            dense
                            color="cyan"
                            filled
                            label="Internal Note"
                            solo
                            flat
                            class="my-2"
                            item-color="cyan"
                            item-text="label"
                            item-value="id"
                            hide-details
                            :disabled="formLoading"
                            :loading="formLoading"
                            :items="adminNoteList"
                            v-model="dbInvoice.admin_note_id"
                            v-on:change="update_admin_note()"
                            v-if="false"
                          >
                          </v-autocomplete>
                          <TinyMCE v-model="dbInvoice.admin_note" />
                        </v-card>
                      </v-col>

                      <!-- Client Note Card -->
                      <v-col cols="12" md="6" class="py-2">
                        <v-card
                          flat
                          outlined
                          class="rounded-lg pa-4 blue lighten-5 h-100"
                        >
                          <div
                            class="d-flex align-center justify-space-between mb-3 pb-2 border-bottom"
                          >
                            <div class="d-flex align-center">
                              <v-icon color="blue" small class="mr-2"
                                >mdi-account-details-outline</v-icon
                              >
                              <div>
                                <label
                                  class="font-weight-bold font-size-16 primary--text mb-0 cursor-pointer"
                                >
                                  Client Note
                                </label>
                                <span
                                  class="font-size-11 grey--text text--darken-1 ml-1"
                                  >(visible on PDF)</span
                                >
                              </div>
                            </div>
                          </div>
                          <v-autocomplete
                            dense
                            color="cyan"
                            filled
                            label="Client Note"
                            solo
                            flat
                            class="my-2"
                            item-color="cyan"
                            item-text="label"
                            item-value="id"
                            hide-details
                            :disabled="formLoading"
                            :loading="formLoading"
                            :items="clientNoteList"
                            v-model="dbInvoice.client_note_id"
                            v-on:change="update_client_note()"
                            v-if="false"
                          >
                          </v-autocomplete>
                          <TinyMCE v-model="dbInvoice.client_note" />
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-layout class="mt-4">
                      <v-flex md12 class="mr-4" v-if="false">
                        <label class="font-size-16 font-weight-500"
                          >Attachments</label
                        >
                        <FileUpload
                          v-model="dbInvoice.attachments"
                          :maxLimit="5"
                        >
                        </FileUpload>
                        <table width="100%" v-if="false">
                          <tbody>
                            <tr
                              v-for="(row, index) in dbInvoice.attachments"
                              :key="`prev-attach-${index}`"
                            >
                              <td width="50%" class="pr-2 py-2">
                                <v-text-field
                                  prepend-inner-icon="mdi-attachment mdi-rotate-90"
                                  placeholder="File Name"
                                  label="File Name"
                                  dense
                                  solo
                                  flat
                                  readonly
                                  color="cyan"
                                  v-model="row.name"
                                  hide-details
                                ></v-text-field>
                              </td>
                              <td width="50%" class="pl-2 py-2">
                                <v-text-field
                                  placeholder="File Name"
                                  label="File Name"
                                  dense
                                  solo
                                  flat
                                  color="cyan"
                                  v-model="row.name"
                                  hide-details
                                  class="has-delete-outer-icon"
                                  append-outer-icon="mdi-delete"
                                  v-on:click:append-outer="
                                    remove_row('dbInvoice.attachments', index)
                                  "
                                  :suffix="`.${row.ext}`"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr
                              v-for="(row, index) in attachments"
                              :key="index"
                            >
                              <td width="50%" class="pr-2 py-2">
                                <v-file-input
                                  prepend-inner-icon="mdi-attachment mdi-rotate-90"
                                  placeholder="Click here to select file"
                                  label="Click here to select file"
                                  prepend-icon=""
                                  color="cyan"
                                  solo
                                  flat
                                  :disabled="formLoading"
                                  :loading="formLoading"
                                  v-model="row.accepted_file"
                                  dense
                                  v-on:change="update_file_name(index)"
                                  hide-details
                                ></v-file-input>
                              </td>
                              <td width="50%" class="pl-2 py-2">
                                <v-text-field
                                  placeholder="File Name"
                                  label="File Name"
                                  dense
                                  solo
                                  flat
                                  :disabled="formLoading"
                                  :loading="formLoading"
                                  color="cyan"
                                  v-model="row.file_name"
                                  :maxlength="250"
                                  hide-details
                                  class="has-delete-outer-icon"
                                  append-outer-icon="mdi-delete"
                                  v-on:click:append-outer="
                                    remove_row('attachments', index)
                                  "
                                  :suffix="get_file_extension(row.file_type)"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td height="10px" colspan="2"></td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                <v-btn
                                  color="cyan white--text"
                                  small
                                  :disabled="formLoading"
                                  v-on:click="add_attachment_row()"
                                  class="custom-bold-button"
                                  >Add More...</v-btn
                                >
                              </td>
                            </tr>
                            <tr>
                              <td height="10px" colspan="2"></td>
                            </tr>
                          </tbody>
                        </table>
                      </v-flex>
                      <v-flex md12 class="">
                        <DocumnetList
                          v-model="dbInvoice.attachments"
                          :document-type="3"
                          :show-append-to-pdf="true"
                        >
                        </DocumnetList>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </perfect-scrollbar>
      <customer-select
        :dialog="customerDialog && !invoiceEditId"
        v-on:close="customerDialog = false"
      />
      <person-select
        :dialog="contactDialog"
        v-on:close="contactDialog = false"
        :type="contactType"
      />

      <address-select
        :dialog="propertyDialog"
        v-on:close="propertyDialog = false"
        :type="propertyType"
        :label="propertyLabel"
      />
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import { mapGetters } from "vuex";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DatePicker from "@/view/components/QDatePicker.vue";
import LineItemV2 from "@/view/pages/partials/Line-Item-Invoice.vue";
import { hasInvalidLineItemQuantity } from "@/core/lib/line-item/line.item.lib";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import moment from "moment-timezone";
import ObjectPath from "object-path";
//import FileUpload from "@/view/components/app-component/FileInput.vue";
import DocumnetList from "@/view/pages/DocumnetList";
import {
  SET_CUSTOMER,
  SET_BILLING,
  SET_BILLING_CONTACT,
  SET_PROPERTY,
  SET_PROPERTY_CONTACT,
  RESET_CREATE_STATE,
} from "@/core/services/store/visit.module";
import { CLEAR_INVOICE } from "@/core/services/store/invoice.module";
import {
  CLEAR_CUSTOMER,
  /* GET_CUSTOMER_RELATED, */
} from "@/core/services/store/customer.module";
import {
  UPLOAD,
  QUERY,
  POST,
  PATCH,
} from "@/core/services/store/request.module";
import {
  SET_UOM,
  SET_GST,
  SET_EDIT_LINE_ITEM,
  SET_EDIT_CALCULATION,
  CLEAR_LINE_ITEM,
} from "@/core/services/store/line.item.module";
import CustomerSelect from "@/view/components/CustomerSelect.vue";
import PersonSelect from "@/view/components/PersonSelect.vue";
import AddressSelect from "@/view/components/AddressSelect.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import KTCookie from "@/assets/js/components/cookie";
import CommonMixin from "@/core/plugins/common-mixin";
import RecurringSchedule from "@/view/pages/invoice/RecurringInvoiceSchedule.vue";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "create-invoice",
  mixins: [ValidationMixin, CommonMixin],
  data() {
    return {
      invoiceEditId: 0,
      isInitialLoad: true,
      formLoading: false,
      invoiceCreated: false,
      formValid: true,
      dbQuotation: {},
      dbVisit: {},
      dbEnquiry: {},
      related_type: 2,
      scheduleKey: Number(new Date()),
      dailogKey: Number(new Date()),
      uniqueId: Number(new Date()),
      is_allowed_recur_invoice: false,
      dbUpdateInvoice: {},
      selectedRelations: [],
      recurringTypeList: [
        {
          value: "daily",
          text: "Daily",
        },
        {
          value: "weakly",
          text: "Weekly",
        },
        {
          value: "monthly",
          text: "Monthly",
        },
        {
          value: "yearly",
          text: "Yearly",
        },
      ],
      dbInvoice: {
        title: null,
        description: null,
        notify_billing_contact_person: null,
        notify_property_contact_person: null,
        barcode: null,
        customer_ref: null,
        date: null,
        payment_due: "2",
        due_date: null,
        ticket: 0,
        visit: 0,
        quotation: 0,
        payment_term_id: 0,
        payment_terms: null,
        term_condition_id: 0,
        term_conditions: null,
        admin_note_id: 0,
        admin_note: null,
        client_note_id: 0,
        client_note: null,
        billing_type: "one-off",
        quotations: [],
        visits: [],
        contracts: [],
        pdf_sources: [],
        recurring_type: "monthly",
        recurring_duration_new: 1,
        attachments: [],
      },
      attachments: [
        {
          accepted_file: null,
          file_name: null,
          file_type: null,
        },
      ],
      adminNoteList: [],
      unit: [],
      clientNoteList: [],
      termsConditionList: [],
      paymentTermList: [],
      paymentDueList: [],
      userList: [],
      contractList: [],
      quotationList: [],
      visitList: [],
      pdfSources: [],
      pdfSourceVisibility: {
        quotation: false,
        contract: false,
        visit: false,
      },
      draggedPdfSource: null,
      lastPdfDropTarget: null,
      selectedVisits: [],
      todayDate: null,
      customerDialog: false,
      propertyType: null,
      propertyLabel: null,
      propertyDialog: false,
      contactType: null,
      contactDialog: false,
      isManualQuotationChange: false,
      isManualContractChange: false,
      selectedQuotations: [],
      selectedContracts: [],
    };
  },
  components: {
    "customer-select": CustomerSelect,
    "person-select": PersonSelect,
    "address-select": AddressSelect,
    "line-item": LineItemV2,
    "date-picker": DatePicker,
    TinyMCE,
    // FileUpload,
    CreateUpdateTemplate,
    DocumnetList,
    RecurringSchedule,
    TextAreaField,
  },
  methods: {
    /*
    getQuotationStatusText(status) {
      const statuses = {
        1: "Draft",
        2: "Accepted",
        3: "Rejected",
        5: "Sent",
        6: "Cancelled",
        11: "Submit For Approval",
      };

      return statuses[Number(status)] || "Unknown";
    },
    getQuotationStatusColor(status) {
      const colors = {
        1: "cyan darken-2",
        2: "green darken-2",
        3: "red darken-2",
        5: "orange darken-2",
        6: "red darken-2",
        11: "#ff7300",
      };

      return colors[Number(status)] || "grey darken-2";
    },
    getQuotationStatusTextColor() {
      return "white";
    }, */
    onQuotationChange(ids) {
      if (this.isInitialLoad && this.invoiceEditId) {
        return;
      }
      this.selectedQuotations = this.quotationList
        .filter((q) => ids.includes(q.id))
        .map((q) => ({
          ...q,
          source_type: 1,
        }));

      this.updateCombinedSources();
    },
    getQuotationItem(item) {
      if (item && typeof item === "object" && item.id) return item;
      return (
        (this.quotationList || []).find((q) => Number(q.id) === Number(item)) ||
        {}
      );
    },
    formatQuotationDate(date) {
      if (!date) return "";
      return this.formatDate(date) || moment(date).format("DD/MM/YYYY");
    },
    getQuotationStatusText(item) {
      if (item?.status_text) {
        return item.status_text;
      }
      const statusMap = {
        1: "Draft",
        2: "Accepted",
        3: "Rejected",
        4: "Pending",
        5: "Sent",
        6: "Cancelled",
        8: "Approved",
        10: "Unapproved",
        11: "Submit For Approval",
      };
      return statusMap[item?.status] || "";
    },
    getQuotationStatusColor(item) {
      if (item?.status_color) {
        return item.status_color;
      }
      const colorMap = {
        1: "cyan",
        2: "green",
        3: "red",
        4: "cyan",
        5: "orange",
        6: "red",
        8: "blue",
        10: "#b71c1c",
        11: "#ff7300",
      };
      return colorMap[item?.status] || "grey";
    },
    getQuotationStatusTextColor(item) {
      if (item?.status_textcolor) {
        return item.status_textcolor;
      }
      return "white";
    },
    quotationFilter(item, queryText) {
      const query = (queryText || "").toLowerCase().trim();
      if (!query) return true;
      const title = (item.job_title || "").toLowerCase();
      const barcode = (item.barcode || "").toLowerCase();
      const date = (this.formatQuotationDate(item.date) || "").toLowerCase();
      const status = (this.getQuotationStatusText(item) || "").toLowerCase();
      return (
        title.includes(query) ||
        barcode.includes(query) ||
        date.includes(query) ||
        status.includes(query)
      );
    },
    removeQuotation(id) {
      const targetId = Number(id);
      const index = (this.dbInvoice.quotations || []).findIndex(
        (val) => Number(val) === targetId
      );
      if (index >= 0) {
        this.dbInvoice.quotations.splice(index, 1);
        this.onQuotationChange(this.dbInvoice.quotations);
      }
    },
    removeVisit(id) {
      const targetId = Number(id);
      const index = (this.dbInvoice.visits || []).findIndex(
        (val) => Number(val) === targetId
      );
      if (index >= 0) {
        this.dbInvoice.visits.splice(index, 1);
        this.onVisitChange(this.dbInvoice.visits);
      }
    },
    applyMultipleQuotations(quotations) {
      this.related_type = 1;

      if (!quotations || !quotations.length) {
        this.dbUpdateInvoice.invoice = [];
        return;
      }

      this.dbUpdateInvoice = {
        ...this.dbUpdateInvoice,
        invoice: quotations,
      };

      //this.uniqueId = Date.now();
    },
    onContractChange(ids) {
      if (this.isInitialLoad && this.invoiceEditId) {
        return;
      }
      this.selectedContracts = this.contractList
        .filter((c) => ids.includes(c.id))
        .map((c) => ({
          ...c,
          source_type: 4,
        }));

      this.updateCombinedSources();
    },
    onVisitChange(ids) {
      if (this.isInitialLoad && this.invoiceEditId) {
        return;
      }
      this.selectedVisits = this.visitList
        .filter((v) => ids.includes(v.id))
        .map((v) => ({
          ...v,
          source_type: 3,
        }));

      this.updateCombinedSources();
    },
    toggleVisit(visit) {
      const selectedIds = (this.dbInvoice.visits || []).map(Number);
      const visitId = Number(visit.id);
      const selected = selectedIds.includes(visitId);

      this.dbInvoice.visits = selected
        ? selectedIds.filter((id) => id !== visitId)
        : [...selectedIds, visitId];
      this.onVisitChange(this.dbInvoice.visits);
    },
    applyMultipleVisits(visits) {
      this.related_type = 3;

      if (!visits || !visits.length) {
        this.dbUpdateInvoice.invoice = [];
        return;
      }

      this.dbUpdateInvoice = {
        ...this.dbUpdateInvoice,
        invoice: visits,
      };
    },
    applyMultipleContracts(contracts) {
      this.related_type = 4;

      if (!contracts || !contracts.length) {
        this.dbUpdateInvoice.invoice = [];
        return;
      }

      this.dbUpdateInvoice = {
        ...this.dbUpdateInvoice,
        invoice: contracts,
      };

      //this.uniqueId = Date.now();
    },
    updateCombinedSources() {
      const combined = [
        ...this.selectedQuotations,
        ...this.selectedContracts,
        ...this.selectedVisits,
      ];

      this.dbUpdateInvoice = {
        ...this.dbUpdateInvoice,
        invoice: combined,
      };

      const sourceTypes = ["quotation", "contract", "visit"];
      const current = Array.isArray(this.dbInvoice.pdf_sources)
        ? this.dbInvoice.pdf_sources
        : [];
      const currentByType = current.reduce((result, source) => {
        result[source.type] = source;
        return result;
      }, {});

      this.dbInvoice.pdf_sources = sourceTypes
        .map((type, index) => ({
          type,
          show_on_pdf: currentByType[type]
            ? currentByType[type].show_on_pdf !== false
            : false,
          order:
            currentByType[type] &&
            Number.isInteger(Number(currentByType[type].order))
              ? Number(currentByType[type].order)
              : index,
        }))
        .sort((a, b) => a.order - b.order)
        .map((source, index) => ({ ...source, order: index }));
      this.pdfSources = this.dbInvoice.pdf_sources;
      this.syncPdfSourceVisibility();
    },
    syncPdfSourceOrder() {
      this.dbInvoice.pdf_sources = this.pdfSources.map((source, index) => ({
        type: source.type,
        show_on_pdf: Boolean(source.show_on_pdf),
        order: index,
      }));
    },
    updatePdfSourceVisibility(type) {
      this.dbInvoice.pdf_sources = this.dbInvoice.pdf_sources.map((source) => ({
        type: source.type,
        show_on_pdf:
          source.type === type
            ? Boolean(this.pdfSourceVisibility[type])
            : Boolean(source.show_on_pdf),
        order: Number(source.order),
      }));
      this.pdfSources = this.dbInvoice.pdf_sources;
    },
    syncPdfSourceVisibility() {
      ["quotation", "contract", "visit"].forEach((type) => {
        const sources = this.dbInvoice.pdf_sources.filter(
          (source) => source.type === type
        );
        this.pdfSourceVisibility[type] =
          sources.length > 0 &&
          sources.every((source) => source.show_on_pdf !== false);
      });
    },
    applySavedPdfSourceOrder() {
      this.$nextTick(() => {
        const sourceRows = Array.from(
          this.$el.querySelectorAll(".pdf-source-drag-handle[data-source-type]")
        ).map((handle) => handle.closest("tr"));
        if (!sourceRows.length) return;

        const rowsByType = sourceRows.reduce((result, row) => {
          const handle = row.querySelector("[data-source-type]");
          result[handle.dataset.sourceType] = row;
          return result;
        }, {});
        const firstRow = sourceRows[0];
        const orderedTypes = this.pdfSources
          .slice()
          .sort((a, b) => Number(a.order) - Number(b.order))
          .map((source) => source.type);

        let cursor = firstRow;
        orderedTypes.forEach((type) => {
          const row = rowsByType[type];
          if (!row) return;
          row.parentNode.insertBefore(row, cursor);
          cursor = row.nextSibling;
        });
      });
    },
    dragPdfSource(type, event) {
      this.draggedPdfSource = type;
      this.lastPdfDropTarget = null;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", type);
      const row = event.currentTarget.closest("tr");
      if (row) {
        row.classList.add("pdf-source-dragging");
        event.dataTransfer.setDragImage(row, 20, row.offsetHeight / 2);
      }
    },
    endDragPdfSource(event) {
      const row = event.currentTarget.closest("tr");
      if (row) {
        row.classList.remove("pdf-source-dragging");
      }
      this.draggedPdfSource = null;
      this.lastPdfDropTarget = null;
    },
    dragOverPdfSource(targetType, event) {
      event.preventDefault();
      if (this.lastPdfDropTarget === targetType) return;
      this.lastPdfDropTarget = targetType;
      this.reorderPdfSource(
        targetType,
        this.draggedPdfSource || event.dataTransfer.getData("text/plain")
      );
    },
    reorderPdfSource(targetType, sourceType) {
      if (!sourceType || sourceType === targetType) return;
      const targetRow = document
        .querySelector(`[data-source-type="${targetType}"]`)
        .closest("tr");
      const sourceRow = document
        .querySelector(`[data-source-type="${sourceType}"]`)
        .closest("tr");
      if (sourceRow && targetRow && sourceRow !== targetRow) {
        const rows = Array.from(
          targetRow.parentNode.querySelectorAll("[data-source-type]")
        ).map((icon) => icon.closest("tr"));
        const sourceIndex = rows.indexOf(sourceRow);
        const targetIndex = rows.indexOf(targetRow);

        if (sourceIndex < targetIndex) {
          targetRow.parentNode.insertBefore(sourceRow, targetRow.nextSibling);
        } else {
          targetRow.parentNode.insertBefore(sourceRow, targetRow);
        }

        const nextOrder = Array.from(
          targetRow.parentNode.querySelectorAll("[data-source-type]")
        ).map((icon) => icon.dataset.sourceType);
        this.pdfSources = this.pdfSources
          .slice()
          .sort(
            (a, b) => nextOrder.indexOf(a.type) - nextOrder.indexOf(b.type)
          );
        this.syncPdfSourceOrder();
      }
    },
    dropPdfSource(targetType, event) {
      event.preventDefault();
      this.reorderPdfSource(
        targetType,
        this.draggedPdfSource || event.dataTransfer.getData("text/plain")
      );
    },
    pdfSourceLabel(source) {
      const collections = {
        quotation: this.quotationList,
        contract: this.contractList,
        visit: this.visitList,
      };
      const item = (collections[source.type] || []).find(
        (row) => Number(row.id) === Number(source.id)
      );
      if (!item) return `${source.type} #${source.id}`;
      return `${source.type.charAt(0).toUpperCase() + source.type.slice(1)}: ${
        item.barcode || item.job_title || item.title || source.id
      }`;
    },
    clearLocalStorage() {
      localStorage.removeItem("milesttone");
    },
    remove_row(target, index) {
      ObjectPath.del(this, `${target}.${index}`);
      this.$nextTick(() => {
        if (!this.attachments.length) {
          this.add_attachment_row();
        }
      });
    },
    add_attachment_row() {
      this.attachments.push({
        accepted_file: null,
        file_name: null,
        file_type: null,
      });
    },
    get_file_extension(file_type) {
      if (file_type) {
        return `.${file_type}`;
      }
      return null;
    },
    update_file_name(index) {
      const file = this.attachments[index].accepted_file;
      if (file) {
        this.attachments[index].file_name = file.name
          .split(".")
          .slice(0, -1)
          .join(".");
        this.attachments[index].file_type = file.name.split(".").pop();
        this.add_attachment_row();
      }
    },
    update_payment_term() {
      let output = this.lodash.find(this.paymentTermList, {
        id: this.dbInvoice.payment_term_id,
      });
      if (output) {
        this.dbInvoice.payment_terms = output.description;
      }
    },
    update_term_condition() {
      let output = this.lodash.find(this.termsConditionList, {
        id: this.dbInvoice.term_condition_id,
      });
      if (output) {
        this.dbInvoice.term_conditions = output.description;
      }
    },
    update_admin_note() {
      let output = this.lodash.find(this.adminNoteList, {
        id: this.dbInvoice.admin_note_id,
      });
      if (output) {
        this.dbInvoice.admin_note = output.description;
      }
    },
    update_client_note() {
      let output = this.lodash.find(this.clientNoteList, {
        id: this.dbInvoice.client_note_id,
      });
      if (output) {
        this.dbInvoice.client_note = output.description;
      }
    },
    uploadFiles() {
      let _this = this;
      return new Promise((resolve, reject) => {
        let formData = new FormData();

        let status = false;

        for (let i = 0; i < _this.attachments.length; i++) {
          if (_this.attachments[i].accepted_file) {
            status = true;
            formData.append(
              `files[${i}]`,
              _this.attachments[i].accepted_file,
              _this.attachments[i].file_name
            );
          }
        }

        if (!status) {
          resolve([]);
        } else {
          _this.$store
            .dispatch(UPLOAD, { url: "file-manager/upload", data: formData })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    openDialog(type) {
      if (type === "customer" && this.invoiceEditId) return;
      this.customerDialog = false;
      this.propertyType = null;
      this.propertyLabel = null;
      this.propertyDialog = false;
      this.contactType = null;
      this.contactDialog = false;

      if (type == "customer") {
        this.customerDialog = true;
      } else {
        if (!this.vCustomerId) {
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "billing") {
          this.propertyType = "billing";
          this.propertyLabel = "Billing Location";
          this.propertyDialog = true;
        }
        if (type == "billing-contact") {
          this.contactType = "billing";
          this.contactDialog = true;
        }
        if (type == "property") {
          this.propertyType = "property";
          this.propertyLabel = "Site Location";
          this.propertyDialog = true;
        }
        if (type == "property-contact") {
          this.contactType = "property";
          this.contactDialog = true;
        }
      }
    },
    validateJob(type) {
      if (!this.vCustomerId) {
        ErrorEventBus.$emit("update:error", "Select Customer");
        return false;
      }

      if (!this.vPropertyId) {
        ErrorEventBus.$emit("update:error", "Select Service Location");
        return false;
      }

      if (!this.vPropertyContactId) {
        ErrorEventBus.$emit("update:error", "Select Service Contact Person");
        return false;
      }

      if (!this.vBillingId) {
        ErrorEventBus.$emit("update:error", "Select Billing Location");
        return false;
      }

      if (!this.vBillingContactId) {
        ErrorEventBus.$emit("update:error", "Select Billing Contact Person");
        return false;
      }

      if (!this.vSelectedLineItem || !this.vSelectedLineItem.length) {
        ErrorEventBus.$emit("update:error", "Select Line Item");
        return false;
      }

      if (hasInvalidLineItemQuantity(this.vSelectedLineItem)) {
        ErrorEventBus.$emit(
          "update:error",
          "Quantity must be at least 1"
        );
        return false;
      }

      const validateStatus = this.$refs.createInvoiceForm.validate();

      const formErrors = this.validateForm(this.$refs.createInvoiceForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (validateStatus) {
        this.onSubmit(type);
      }
    },
    async onSubmit(type) {
      const new_attachments = await this.uploadFiles();
      this.dbInvoice.quotation = this.$route?.query?.quotation
        ? this.lodash.toSafeInteger(this.$route.query.quotation)
        : null;
      const request = {
        ...this.dbInvoice,
        attachments: [...this.dbInvoice.attachments, ...new_attachments],
        customer: this.vCustomerId,
        property: this.vPropertyId,
        sent: type == "send" ? 1 : 0,
        recurring:
          this.dbInvoice.billing_type == "recurring"
            ? this.invoiceRecurringSchedule
            : {},
        schedule:
          this.dbInvoice.billing_type == "recurring"
            ? this.invoiceScheduleOutput
            : [],
        billing: this.vBillingId,
        property_contact_person: this.vPropertyContactId,
        billing_contact_person: this.vBillingContactId,
        visit: this.lodash.toSafeInteger(this.dbVisit?.id),
        enquiry: this.lodash.toSafeInteger(this.dbEnquiry?.id),
        ticket: this.lodash.toSafeInteger(this.dbVisit?.ticket),
        milestone: this.$route?.query?.milestone
          ? this.lodash.toSafeInteger(this.$route.query.milestone)
          : null,
        milestone_amount: this.$route?.query?.milestone_amount
          ? this.$route.query.milestone_amount
          : null,
        payment_type: this.$route?.query?.payment
          ? this.$route?.query?.payment
          : null,
        "line-item": this.vSelectedLineItem,
        calculation: this.vCalculations,
      };

      this.formLoading = true;
      let requestType = POST;
      let requestURL = "invoice-v1";

      let invoiceId = this.$route?.query?.invoice ?? 0;

      if (invoiceId) {
        requestType = PATCH;
        requestURL = `invoice-v1/${invoiceId}`;
      }

      this.$store
        .dispatch(requestType, { url: requestURL, data: request })
        .then(({ data }) => {
          this.invoiceCreated = true;
          this.$store.dispatch(CLEAR_CUSTOMER);
          this.$store.dispatch(RESET_CREATE_STATE);
          this.$store.dispatch(CLEAR_LINE_ITEM);
          /*      this.clearLocalStorage(); */
          this.$nextTick(() => {
            if (requestType == POST) {
              this.$router.push(this.getDefaultRoute("invoice"));
            } else {
              this.$router.push(
                this.getDefaultRoute("invoice.detail", {
                  params: { id: data?.id },
                })
              );
            }
          });
        })
        .catch(() => {
          this.formLoading = false;
        });
    },
    get_attributes() {
      this.formLoading = true;

      this.$store
        .dispatch(QUERY, {
          url: "invoice/options",
          data: {
            ...this.$route.query,
            invoice: ObjectPath.get(this.$route, "params.id"),
          },
        })
        .then((response) => {
          this.is_allowed_recur_invoice = ObjectPath.get(
            response,
            "data.is_allowed_recur_invoice"
          );
          this.dbInvoice.barcode = ObjectPath.get(response, "data.barcode");
          this.dbUpdateInvoice = ObjectPath.get(response, "data");
          if (this.dbUpdateInvoice?.invoice?.barcode) {
            this.dbInvoice.barcode = this.dbUpdateInvoice?.invoice?.barcode;
          }
          this.dbQuotation = ObjectPath.get(response, "data.quotation");
          this.dbEnquiry = ObjectPath.get(response, "data.enquiry");
          this.dbVisit = ObjectPath.get(response, "data.visit");
          this.unit = ObjectPath.get(response, "data.uom_list");

          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Invoice", route: "invoice" },
            { title: "Create" },
            { title: this.dbInvoice.barcode },
          ]);

          this.$store.dispatch(
            SET_UOM,
            ObjectPath.get(response, "data.uom_list", [])
          );
          this.$store.dispatch(
            SET_GST,
            ObjectPath.get(response, "data.entity.gstvalue", 0)
          );
          this.adminNoteList = ObjectPath.get(
            response,
            "data.admin_notes_list",
            []
          );
          this.clientNoteList = ObjectPath.get(
            response,
            "data.client_notes_list",
            []
          );
          this.paymentTermList = ObjectPath.get(
            response,
            "data.payment_terms_list",
            []
          );
          this.termsConditionList = ObjectPath.get(
            response,
            "data.term_conditions_list",
            []
          );
          this.paymentDueList = ObjectPath.get(
            response,
            "data.payment_terms",
            []
          );

          let defaultPaymentTermObject = this.lodash.find(
            this.paymentTermList,
            {
              primary: 1,
            }
          );
          if (defaultPaymentTermObject) {
            this.dbInvoice.payment_term_id = defaultPaymentTermObject.id;
            this.dbInvoice.payment_terms = defaultPaymentTermObject.description;
          }

          let defaultTermConditionObject = this.lodash.find(
            this.termsConditionList,
            {
              primary: 1,
            }
          );
          if (defaultTermConditionObject) {
            this.dbInvoice.term_condition_id = defaultTermConditionObject.id;
            this.dbInvoice.term_conditions =
              defaultTermConditionObject.description;
          }

          let defaultClientObject = this.lodash.find(this.clientNoteList, {
            primary: 1,
          });
          if (defaultClientObject) {
            this.dbInvoice.client_note_id = defaultClientObject.id;
            this.dbInvoice.client_note = defaultClientObject.description;
          }

          let defaultAdminObject = this.lodash.find(this.adminNoteList, {
            primary: 1,
          });
          if (defaultAdminObject) {
            this.dbInvoice.admin_note_id = defaultAdminObject.id;
            this.dbInvoice.admin_note = defaultAdminObject.description;
          }
          if (this.dbUpdateInvoice?.invoice?.id) {
            this.dbInvoice.contracts =
              this.dbUpdateInvoice?.invoice?.contracts || [];
            this.dbInvoice.quotations =
              this.dbUpdateInvoice?.invoice?.quotations || [];
            this.dbInvoice.visits = this.dbUpdateInvoice?.invoice?.visits || [];
            this.dbInvoice.pdf_sources =
              this.dbUpdateInvoice?.invoice?.pdf_sources || [];
            this.pdfSources = this.dbInvoice.pdf_sources
              .slice()
              .sort((a, b) => Number(a.order) - Number(b.order));
            this.syncPdfSourceVisibility();
            this.applySavedPdfSourceOrder();
            this.dbInvoice.admin_note_id =
              this.dbUpdateInvoice?.invoice?.admin_note_id;
            this.dbInvoice.admin_note =
              this.dbUpdateInvoice?.invoice.admin_note;

            this.dbInvoice.client_note_id =
              this.dbUpdateInvoice?.invoice?.client_note_id;
            this.dbInvoice.client_note =
              this.dbUpdateInvoice?.invoice.client_note;

            this.dbInvoice.term_condition_id =
              this.dbUpdateInvoice?.invoice.term_condition_id;
            this.dbInvoice.term_conditions =
              this.dbUpdateInvoice?.invoice.term_conditions;

            this.dbInvoice.payment_term_id =
              this.dbUpdateInvoice?.invoice.payment_term_id;
            this.dbInvoice.payment_terms =
              this.dbUpdateInvoice?.invoice.payment_terms;

            this.dbInvoice.title = this.dbUpdateInvoice?.invoice?.title;
            this.dbInvoice.billing_type = this.getInvoiceType(
              this.dbUpdateInvoice?.invoice?.billing_type
            );
            this.dbInvoice.recurring_duration_new =
              this.dbUpdateInvoice?.invoice?.recurring_duration_new;
            this.dbInvoice.recurring_type =
              this.dbUpdateInvoice?.invoice?.recurring_type;
            this.dbInvoice.description =
              this.dbUpdateInvoice?.invoice?.description;
            this.dbInvoice.customer_ref =
              this.dbUpdateInvoice?.invoice?.customer_ref;
            this.dbInvoice.date = this.dbUpdateInvoice?.invoice?.date;

            this.dbInvoice.notify_billing_contact_person =
              this.dbUpdateInvoice?.invoice?.notify_billing_contact_person;
            this.dbInvoice.notify_property_contact_person =
              this.dbUpdateInvoice?.invoice?.notify_property_contact_person;

            this.dbInvoice.attachments = [];

            this.$store.commit(
              SET_CUSTOMER,
              this.dbUpdateInvoice?.invoice?.customer_relation
            );
            this.$store.commit(
              SET_PROPERTY,
              this.dbUpdateInvoice?.invoice?.property_relation
            );
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbUpdateInvoice?.invoice?.property_contact_person_relation
            );
            this.$store.commit(
              SET_BILLING,
              this.dbUpdateInvoice?.invoice?.billing_relation
            );
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbUpdateInvoice?.invoice?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_EDIT_CALCULATION, {
              ctx_discount_label:
                this.dbUpdateInvoice?.invoice?.ctx_discount_label ?? null,
              ctx_discount_value:
                this.dbUpdateInvoice?.invoice?.ctx_discount_value ?? 0,
              ctx_discount_type:
                this.dbUpdateInvoice?.invoice?.ctx_discount_type ?? 1,
              discount_type: this.dbUpdateInvoice?.invoice?.discount_type ?? 1,
              discount_value:
                this.dbUpdateInvoice?.invoice?.discount_value ?? 0,
              tax_active: this.dbUpdateInvoice?.invoice?.tax_active ?? false,
              adjustment: this.dbUpdateInvoice?.invoice?.adjustment ?? 0,
              show_price: true,
              discount_level:
                this.dbUpdateInvoice?.invoice?.discount_level ?? "transaction",
            });

            this.$store.dispatch(
              SET_EDIT_LINE_ITEM,
              this.dbUpdateInvoice?.invoice?.line_item ?? []
            );
            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Invoice", route: "invoice" },
              { title: "Update" },
              { title: this.dbInvoice.barcode },
            ]);
          }
          if (this.dbQuotation?.id) {
            this.dbUpdateInvoice.invoice = this.dbQuotation;
            this.related_type = 1;
            this.dbInvoice.title = this.dbQuotation?.title;
            this.dbInvoice.billing_type = this.getInvoiceType(
              this.dbQuotation?.billing_type
            );
            this.dbInvoice.recurring_duration_new =
              this.dbQuotation?.recurring_duration_new;
            this.dbInvoice.recurring_type = this.dbQuotation?.recurring_type;
            this.dbInvoice.description = this.dbQuotation?.description;
            this.dbInvoice.customer_ref = this.dbQuotation?.reference;

            this.dbInvoice.notify_billing_contact_person =
              this.dbQuotation?.notify_billing_contact_person;
            this.dbInvoice.notify_property_contact_person =
              this.dbQuotation?.notify_property_contact_person;

            this.dbInvoice.client_note_id = 0;
            this.dbInvoice.client_note = this.dbQuotation?.client_note;

            this.dbInvoice.admin_note_id = 0;
            this.dbInvoice.admin_note = this.dbQuotation?.admin_note;
            this.dbInvoice.attachments = [];
            this.dbInvoice.billing_type = "one-off";
            this.$store.commit(
              SET_CUSTOMER,
              this.dbQuotation?.customer_relation
            );
            this.$store.commit(
              SET_PROPERTY,
              this.dbQuotation?.property_relation
            );
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbQuotation?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, this.dbQuotation?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbQuotation?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_EDIT_CALCULATION, {
              ctx_discount_label: this.dbQuotation?.ctx_discount_label ?? null,
              ctx_discount_value: this.dbQuotation?.ctx_discount_value ?? 0,
              ctx_discount_type: this.dbQuotation?.ctx_discount_type ?? 1,
              discount_type: this.dbQuotation?.discount_type ?? 1,
              discount_value: this.dbQuotation?.discount_value ?? 0,
              tax_active: this.dbQuotation?.tax_active ?? false,
              adjustment: this.dbQuotation?.adjustment ?? 0,
              show_price: true,
              discount_level: this.dbQuotation?.discount_level ?? "transaction",
            });

            this.$store.dispatch(
              SET_EDIT_LINE_ITEM,
              this.dbQuotation?.line_item ?? []
            );
          }
          if (this.dbEnquiry?.id) {
            this.dbUpdateInvoice.invoice = this.dbEnquiry;
            this.related_type = 6;
            this.dbInvoice.title = this.dbEnquiry?.title;
            this.dbInvoice.description = this.dbEnquiry?.problem;
            this.dbInvoice.customer_ref = this.dbEnquiry?.reference;
            this.dbInvoice.attachments = [];
            this.dbInvoice.billing_type = "one-off";
            this.$store.commit(SET_CUSTOMER, this.dbEnquiry?.customer_relation);
            this.$store.commit(SET_PROPERTY, this.dbEnquiry?.property_relation);
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbEnquiry?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, this.dbEnquiry?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbEnquiry?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_EDIT_CALCULATION, {
              ctx_discount_label: this.dbEnquiry?.ctx_discount_label ?? null,
              ctx_discount_value: this.dbEnquiry?.ctx_discount_value ?? 0,
              ctx_discount_type: this.dbEnquiry?.ctx_discount_type ?? 1,
              discount_type: this.dbEnquiry?.discount_type ?? 1,
              discount_value: this.dbEnquiry?.discount_value ?? 0,
              tax_active: this.dbEnquiry?.tax_active ?? false,
              adjustment: this.dbEnquiry?.adjustment ?? 0,
              show_price: true,
              discount_level: this.dbEnquiry?.discount_level ?? "transaction",
            });

            this.$store.dispatch(
              SET_EDIT_LINE_ITEM,
              this.dbEnquiry?.line_item ?? []
            );
          }

          if (this.dbVisit?.id) {
            this.dbUpdateInvoice.invoice = this.dbVisit;
            this.related_type = 3;
            this.dbInvoice.title = this.dbVisit?.title;
            // this.dbInvoice.billing_type = this.dbVisit?.billing_type;
            this.dbInvoice.recurring_duration_new =
              this.dbVisit?.recurring_duration_new;
            this.dbInvoice.recurring_type = this.dbVisit?.recurring_type;
            this.dbInvoice.description = this.dbVisit.description
              ? this.dbVisit.description.replace(/<[^>]*>/g, "")
              : "";
            this.dbInvoice.customer_ref = this.dbVisit?.reference;
            this.dbInvoice.billing_type = "one-off";

            /*      this.dbInvoice.notify_billing_contact_person =
              this.dbVisit?.notify_billing_contact_person;
            this.dbInvoice.notify_property_contact_person =
              this.dbVisit?.notify_property_contact_person; */

            this.dbInvoice.client_note_id = 0;
            this.dbInvoice.client_note = this.dbVisit?.client_note;

            this.dbInvoice.admin_note_id = 0;
            this.dbInvoice.admin_note = this.dbVisit?.admin_note;
            this.dbInvoice.term_conditions = this.dbVisit?.term_conditions;
            this.dbInvoice.term_condition_id = this.dbVisit?.term_condition_id;
            this.dbInvoice.attachments = this.dbVisit?.attachments;
            this.$store.commit(SET_CUSTOMER, this.dbVisit?.customer_relation);
            this.$store.commit(SET_PROPERTY, this.dbVisit?.property_relation);
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              this.dbVisit?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, this.dbVisit?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              this.dbVisit?.billing_contact_person_relation
            );
          }
        })
        .catch((error) => {
          this.logError(error);
          /*  this.goBack(); */
        })
        .finally(() => {
          this.formLoading = false;
          this.$nextTick(() => {
            setTimeout(() => {
              this.isInitialLoad = false;
            }, 500);
          });
        });
    },
    getInvoiceType(type) {
      if (type == "one-off") {
        return "one-off";
      } else if (type == "recurring-based-on-quote") {
        return "recurring";
      } else if (type == "recurring") {
        return "recurring";
      }
    },
    async fetchContracts(customerId) {
      try {
        const response = await this.$store.dispatch(QUERY, {
          url: "contract-list",
          data: {
            customer: customerId,
          },
        });

        this.contractList = (response?.data || []).map((item) => ({
          ...item,
          id: Number(item.id),
        }));
        this.dbInvoice.contracts = [...this.dbInvoice.contracts];
        if (this.dbInvoice.contracts && this.dbInvoice.contracts.length) {
          this.selectedContracts = this.contractList
            .filter((c) => this.dbInvoice.contracts.includes(c.id))
            .map((c) => ({ ...c, source_type: 4 }));
          if (!this.invoiceEditId) {
            this.updateCombinedSources();
          }
        }
      } catch (error) {
        console.log(error);
        this.contractList = [];
      }
    },
    async fetchQuotations(customerId) {
      try {
        const response = await this.$store.dispatch(QUERY, {
          url: "contract/quotation",
          data: {
            customer: customerId,
          },
        });

        this.quotationList = (response?.data || []).map((item) => ({
          ...item,
          id: Number(item.id),
        }));
        this.dbInvoice.quotations = [...this.dbInvoice.quotations];
        if (this.dbInvoice.quotations && this.dbInvoice.quotations.length) {
          this.selectedQuotations = this.quotationList
            .filter((q) => this.dbInvoice.quotations.includes(q.id))
            .map((q) => ({ ...q, source_type: 1 }));
          if (!this.invoiceEditId) {
            this.updateCombinedSources();
          }
        }
      } catch (error) {
        console.log(error);
        this.quotationList = [];
      }
    },
    async fetchVisits(customerId) {
      try {
        const response = await this.$store.dispatch(QUERY, {
          url: "invoice-visit-list",
          data: {
            customer: customerId,
          },
        });

        this.visitList = (response?.data || []).map((item) => ({
          ...item,
          id: Number(item.id),
        }));
        this.dbInvoice.visits = [...this.dbInvoice.visits];
        // If there are preselected visit ids, populate selectedVisits for combined source handling
        if (this.dbInvoice.visits && this.dbInvoice.visits.length) {
          this.selectedVisits = this.visitList
            .filter((v) => this.dbInvoice.visits.includes(v.id))
            .map((v) => ({ ...v, source_type: 3 }));
          if (!this.invoiceEditId) {
            this.updateCombinedSources();
          }
        }
      } catch (error) {
        console.log(error);
        this.visitList = [];
      }
    },
    applyQuotationToInvoice(quotation) {
      this.related_type = 1;
      this.dbUpdateInvoice = {
        ...this.dbUpdateInvoice,
        invoice: { ...quotation },
      };

      this.uniqueId = Date.now();
    },
    applyContractToInvoice(contract) {
      this.related_type = 4;
      this.dbUpdateInvoice = {
        ...this.dbUpdateInvoice,
        invoice: { ...contract },
      };

      //   this.uniqueId = Date.now()
    },
  },
  watch: {
    vCustomerId: {
      handler(newVal) {
        if (newVal) {
          this.fetchContracts(newVal);
          this.fetchQuotations(newVal);
          this.fetchVisits(newVal);
        } else {
          this.contractList = [];
          this.quotationList = [];
          this.visitList = [];
        }
      },
      immediate: true,
    },

    /* $route (to, from){
          if(to != from){
            this.clearLocalStorage()
          }
      } */
    /*  vCustomerId(param) {
          this.$store.dispatch(GET_CUSTOMER_RELATED, {
            id: param,
            type: ["quotation", "visit","invoice"],
          });
        }, */
  },
  mounted() {
    this.get_attributes();
    this.invoiceEditId = this.lodash.toSafeInteger(this.$route.params.id);
    if (this.dbUpdateInvoice?.invoice?.id > 1) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Invoice", route: "invoice" },
        { title: "Update" },
      ]);
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Invoice", route: "invoice" },
        { title: "Create" },
      ]);
    }
  },
  destroyed() {
    this.$store.dispatch(CLEAR_INVOICE);
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    this.$store.dispatch(CLEAR_LINE_ITEM);
  },
  beforeDestroy() {
    KTCookie.setCookie("kt_aside_toggle_state", "off");
    localStorage.setItem("kt_aside_toggle_state", "off");
  },
  created() {
    this.invoiceEditId =
      this.lodash.toSafeInteger(this.$route?.params?.id) || 0;
    this.todayDate = moment().format("YYYY-MM-DD");
    this.dbInvoice.date = this.todayDate;
    this.dbInvoice.ticket = ObjectPath.get(this.$route, "query.ticket");
    this.dbInvoice.visit = ObjectPath.get(this.$route, "query.visit");
    this.dbInvoice.quotation = ObjectPath.get(this.$route, "query.quotation");
  },
  beforeCreate() {
    KTCookie.setCookie("kt_aside_toggle_state", "on");
    localStorage.setItem("kt_aside_toggle_state", "on");
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    this.$store.dispatch(CLEAR_LINE_ITEM);
  },
  computed: {
    ...mapGetters([
      "vRelatedQuotations",
      "vRelatedVisits",
      "vCustomer",
      "vProperty",
      "vPropertyContact",
      "vBilling",
      "vBillingContact",
      "vCustomerId",
      "vPropertyId",
      "vPropertyContactId",
      "vBillingId",
      "vBillingContactId",
      "vSelectedLineItem",
      "vCalculations",
      "recurringInvoiceScheduleTypeList",
      "invoiceRecurringSchedule",
      "invoiceScheduleOutput",
      "customError",
    ]),
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.invoiceCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.invoice-create-page {
  border-top: solid 8px #f7941e;
  label {
    padding-left: 5px;
    font-weight: 600;
  }
  p {
    padding-left: 5px;
  }
}
.form-action {
  display: flex;
  justify-content: space-between;

  .form-title {
    font-size: 24px;
    font-family: "Poppins", Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #24326d;
    letter-spacing: 1.5px;
    line-height: 1.11em;
    .form-title-link {
      color: #4d6974;
      border-bottom: dashed 2px #4d6974;
    }
  }
}
.pdf-source-drag-handle {
  cursor: grab;
  color: #24326d !important;
  margin-left: -10px;
  margin-right: 8px;
}
.pdf-source-drag-handle .v-icon {
  color: #24326d !important;
}
.pdf-source-drag-handle:active {
  cursor: grabbing;
}
.pdf-source-dragging {
  opacity: 0.45;
}
.pdf-source-row {
  background: transparent;
  border: 0;
}
.pdf-source-row > td {
  padding: 10px 12px;
}
.invoice-details-table {
  table-layout: auto !important;
  border-collapse: collapse;
  border-spacing: 0;
}
.invoice-details-table {
  table-layout: auto !important;
}
.invoice-details-table .pdf-source-control-cell {
  width: 100% !important;
  min-width: 0 !important;
}
.pdf-source-control-cell {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  width: 100% !important;
  white-space: nowrap;
}
.pdf-source-control-cell > .v-tooltip {
  order: 2;
  flex: 0 0 auto;
}
.pdf-source-autocomplete {
  order: 1;
  display: flex !important;
  flex: 1 1 0 !important;
  min-width: 0;
  width: 100% !important;
  vertical-align: middle;
}
.pdf-source-autocomplete .v-input__control,
.pdf-source-autocomplete .v-input__slot {
  width: 100% !important;
}
.pdf-source-checkbox {
  width: auto;
  margin-left: 12px;
  vertical-align: middle;
}
.pdf-source-visibility-checkbox {
  margin: 0 !important;
}
</style>
